import {ListView as ListViewComponent} from './ListView'
import {Metadata} from './Metadata'
import {SectionFilterLink} from './SectionFilterLink'
import {ActionBar} from './ActionBar'
import {SelectionProvider} from './SelectionContext'
import {Note} from './Note'
import {DensityToggle} from './DensityToggle'
import {MultiPageSelectionProvider} from './MultiPageSelectionContext'

export type {ListViewProps} from './ListView'
export type {NoteProps as ListViewNoteProps} from './Note'
export type {DensityToggleProps as ListViewDensityToggleProps} from './DensityToggle'
export type {SectionFilterLinkProps as ListViewSectionFilterLinkProps} from './SectionFilterLink'
export type {SectionFilterLinks as ListViewSectionFilterLinks} from './SectionFilters'
export {useListViewMultiPageSelection} from './MultiPageSelectionContext'

export const ListView = Object.assign(ListViewComponent, {
  /**
   * The metadata container provides an area for content such as status and selection of Open and Closed Issues, list
   * sorting criteria, display density toggling, and other bulk-level actions. Optional.
   */
  Metadata,
  /**
   * This subcomponent allows a user to know how many list items have a categorically filterable computed status
   * applied to them. It also allows a user to filter the ListView's list items to only show items with one of the
   * mutually exclusive category filters. Optional. If utilized, section filter links must be mutually
   * exclusive. Examples of this are Open/Closed, Public/Private, Passed/Failed, etc.
   */
  SectionFilterLink,
  /**
   * Controls for manipulating list items, such as altering their display density or sort order.
   */
  ActionBar,
  MultiPageSelectionProvider,
  SelectionProvider,
  /**
   * This subcomponent allows a user to add a row of additional context into the ListView and should be used sparingly.
   * A note will be visually distinct from a ListItem but adheres to the same keyboard navigation rules.
   * The most common use cases for a Note will be at the start/end of a ListView or ListGroup.
   */
  Note,
  /**
   * Toggle control to toggle how compactly list items are displayed.
   */
  DensityToggle,
})
